import { useMutation, useQuery, useQueryClient } from 'react-query';

import { FormActions, NotificationPosition } from 'coreOld/enums';
import { useHandleErrors } from 'coreOld/hooks';
import { actionLoadingMessage, actionMessage } from 'coreOld/utils';
import { ranksService } from 'system/services';

export const useGetRanks = () => {
  const { data, isError, isLoading, isFetching, error } = useQuery(
    ['ranks'],
    ({ signal }) => ranksService.getAllRanks(signal),
    {
      keepPreviousData: true,
    }
  );

  return {
    records: data?.records ?? [],
    count: data?.count ?? 0,
    isError,
    isLoading,
    isFetching,
    statusCode: (error as any)?.response?.status ?? null,
  };
};

export const useRanksActions = () => ({
  ...useUpsertRank(),
  ...useRemoveRank(),
});

const useUpsertRank = () => {
  const queryClient = useQueryClient();

  const { errors } = useHandleErrors(
    actionMessage('Rank'),
    actionLoadingMessage('rank'),
    NotificationPosition.MODAL,
    ['ranks'],
    FormActions.UPSERT
  );

  const { mutateAsync } = useMutation((data) => ranksService.upsertRank(data), {
    onSuccess: (data) => {
      queryClient.invalidateQueries(['ranks', data?.data?.internalReference]);
    },
    ...errors,
  });

  const upsertRank = (data) => mutateAsync(data);

  return { upsertRank };
};

const useRemoveRank = () => {
  const queryClient = useQueryClient();

  const { errors } = useHandleErrors(
    actionMessage('Rank'),
    actionLoadingMessage('rank'),
    NotificationPosition.MODAL,
    ['ranks'],
    FormActions.REMOVE
  );

  const { mutateAsync } = useMutation((data) => ranksService.removeRank(data), {
    onSuccess: (data) => {
      queryClient.invalidateQueries(['ranks', data?.data?.internalReference]);
    },
    ...errors,
  });

  const removeRank = (data) => mutateAsync(data);

  return { removeRank };
};
